import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { IAssessmentState } from '../store/assessment.types'
import { getAssessmentSelector } from '../selectors'
import { AssessmentConstants } from '../store/assessment.constant'

export function* setSepsisIndicators() {
  try {
    const procedureState: IProcedureState = yield select(getProcedureStateSelector)
    const assessmentState: IAssessmentState = yield select(getAssessmentSelector)
    const { inputRows } = procedureState
    const { sepsisIndicators } = assessmentState
    inputRows.forEach((row) =>
      row.inputs.forEach((input) => {
        if (input.key === AssessmentConstants.SET_SEPSIS_INDICATORS) {
          //@ts-ignore
          input.props.savedValues = sepsisIndicators
        }
      })
    )
    yield put(setInputRows(inputRows))
  } catch (e) {
    yield put(throwPcrException(`setSepsisIndicatorsSaga() error: ${e}`))
  }
}
export function* setSepsisIndicatorsSaga() {
  yield takeLatest([AssessmentConstants.SET_SEPSIS_INDICATORS], performWithMutexHOG, setSepsisIndicators)
}
